import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

export type ContainerLength = 20 | 40

type Props<M extends boolean = false> = {
  onChange: (containerLength: M extends true ? ContainerLength[] : ContainerLength) => void
} & TomAutoCompleteProps<ContainerLength, M>

export const ContainerLengthAutoComplete = observer(
  <M extends boolean = false>(props: Props<M>) => {
    const { t } = useTranslate()
    const { dataCy, defaultValue, label, onChange } = props

    const [options] = useState<ContainerLength[]>([20, 40])

    return (
      <TomAutoComplete
        {...props}
        dataCy={dataCy ?? 'container-length-autocomplete'}
        label={label ?? t('sizeLength', 'Size/Length')}
        options={options}
        defaultValue={defaultValue}
        enablePortal
        placeholder={t('selectContainerLength', 'Select container length')}
        onChangeEntity={entity =>
          onChange(entity as M extends true ? ContainerLength[] : ContainerLength)
        }
      />
    )
  },
)
